import { Observer } from 'mobx-react-lite';
import React from 'react';
import { Form } from '../../mediators/form.mediator';
import joinClassName from '../../utils/className.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import ColorPicker, { ColorPickerProps } from '../ColorPicker/ColorPicker';
import { useFormContext } from '../FormForm/Form.context';
// import './FormColorPicker.scss';

type FormColorPickerProps<T extends object = object> = Omit<ColorPickerProps<T>, 'form'> & {
  form?: Form<T>,
}

function FormColorPicker<T extends object = object>(
  props: FormColorPickerProps<T>
) {

  const context = useFormContext<T>();
  const { form } = context;
  const p = useProps(props);
  const s = useStore(() => ({
    get form() { return p.form ?? form },
  }));

  return <Observer children={() => (
    <ColorPicker {...p}
      className={joinClassName('FormColorPicker', p.className)}
      form={s.form.fields[p.field]}
      field="value"
      name={p.name ?? p.field}
      disabled={p.disabled || context.disabled}
    />
  )} />
}

export default FormColorPicker;